import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: null,
  searchText: null,
  onlyAtivos: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
